import React from 'react'
import InstagramIcon from '@mui/icons-material/Instagram';

const Instagram = () => {
    return (
        <div>
        <InstagramIcon color ="warning" />
            Instagram
        </div>
    )
}

export default Instagram
